<template>
  <CurrentEventDataProvider>
    <SponsorsDataProvider>
      <div class="sponsors-container h-full flex flex-col justify-center">
        <div class="flex flex-wrap justify-center">
          <tappin-top-sponsors
            ref="topSponsorsWc"
            class="mx-auto w-large"
            colorScheme="primary"
            :caption="options.label"
            :size="options.size"
          >
          </tappin-top-sponsors>
        </div>
      </div>
    </SponsorsDataProvider>
  </CurrentEventDataProvider>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    options: Object
  },
  data() {
    return {
      translations: {},
      sponsorsElement: null
    };
  },
  mounted() {
    this.sponsorsElement = this.$refs.topSponsorsWc;

    if (!this.sponsorsElement) {
      console.error(`topSponsorsWc element was not found`);
      return;
    }

    this.sponsorsElement.designStyles = this.getWebComponentStyles;
    this.sponsorsElement.translations = this.translations;
    // Set size directly on the element property (like sponsors/designStyles)
    // rather than relying only on the `:size` attribute binding, so the
    // web component's --card-size scaling reliably picks up the admin value.
    this.sponsorsElement.size = this.options.size;
    this.sponsorsElement.sponsors = this.options.elements.map((element) =>
      this.sponsors?.find((sponsor) => sponsor.id === element.sponsorId)
    );

    this.sponsorsElement.addEventListener('sponsorClick', (e) => {
      const sponsorId = e.detail?.sponsor?.id;
      if (!sponsorId) {
        return;
      }

      this.$router.push({
        name: 'sponsor',
        params: { sponsorId }
      });
    });
  },
  watch: {
    // Re-apply everything to the web component whenever the lobby config
    // changes (e.g. the admin updates the Top Sponsors "Size" or the chosen
    // sponsors and it arrives live via `event-change`). `mounted` only runs
    // once, so without this the size/logos would stay at whatever they were
    // when the section first mounted.
    options: {
      deep: true,
      handler() {
        const el = this.sponsorsElement || this.$refs.topSponsorsWc;
        if (!el) {
          return;
        }
        el.size = this.options.size;
        el.designStyles = this.getWebComponentStyles;
        el.sponsors = (this.options.elements || []).map((element) =>
          this.sponsors?.find((sponsor) => sponsor.id === element.sponsorId)
        );
      }
    },
    '$store.state.Sponsors.items': function (newSponsors) {
      this.sponsorsElement.sponsors = this.options.elements.map((element) =>
        newSponsors.find((sponsor) => sponsor.id === element.sponsorId)
      );
    }
  },
  computed: {
    ...mapGetters('CurrentEvent', ['getWebComponentStyles']),
    ...mapGetters('Sponsors', { sponsors: 'getItems' })
  }
};
</script>
<style scoped lang="scss">
.sponsors-container {
  background-color: var(--color-primary-bg);
}
.w-large {
  width: 1060px;
}
</style>
